import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { system } from '@eastcoal/common/config/system'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'
import { normalizeUrl } from '@eastcoal/common/utils/url'

import { AnnouncementPreviewButtonProps } from './interface'

export const AnnouncementPreviewButton = ({
  detailPath,
  record
}: AnnouncementPreviewButtonProps) => {
  const to = stringifyUrl({
    url: normalizeUrl(system.router.mallBaseUrl, detailPath),
    query: {
      id: record.id
    }
  })
  return (
    <NavigateButton newtab to={to}>
      预览
    </NavigateButton>
  )
}
